const About = ({ aboutData, doctorName }) => {
  const { title, subtitle, content } = aboutData;

  return (
    <>
      <section className="doctor-profile-about-section" data-sal="fade" data-sal-duration="300">
        <div className="container py-5">
          <div className="row" data-sal="slide-up" data-sal-duration="300">
            <div className="col-12" data-sal="fade">
              <h2 className="section-title text-capitalize">{title || doctorName}</h2>
              {subtitle && <p className="section-subtitle">{subtitle}</p>}
            </div>
            <div className="col-12">
              <div
                className="doctor-profile-about-content px-lg-5"
                data-sal="slide-up"
                data-sal-duration="300"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;